var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergezee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.9 27.3",
    style: {
      enableBackground: "new 0 0 199.9 27.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00C281;}\n\t.st1{fill:#00C281;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000152943606296692828500000016672836752593675401_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,11.8l15.5,8.6v-4.3L0,7.5V11.8z M0,18.8l15.5,8.6V23L0,14.4V18.8z M0,4.3l15.5,8.6V8.6L0,0V4.3z  M15.8,27.3l15.5-8.6v-4.3L15.8,23V27.3z M15.8,16v4.3l15.5-8.5V7.5L15.8,16z M31.2,0L15.8,8.6v4.3l15.5-8.6V0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.1,18.2v1.9h-9.7V4.5h9.6v1.9h-7.3v4.9h5.9v1.8h-5.9v5.1L59.1,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,4.5v15.6h-1.2c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.2-0.4-0.3L68.7,8.3c0,0.2,0,0.4,0,0.6s0,0.4,0,0.5 v10.7h-2V4.5h1.2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.2,0.3,0.3l8.8,11.4c0-0.2,0-0.4,0-0.6s0-0.4,0-0.6V4.5H79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.7,18.2v1.9h-9.7V4.5h9.7v1.9h-7.3v4.9h5.9v1.8h-5.9v5.1L97.7,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,20.1h-2c-0.4,0-0.7-0.2-0.9-0.5l-3.8-5.4c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.1-0.7-0.1h-1.5v6.4 h-2.3V4.5h4.5c0.9,0,1.7,0.1,2.6,0.3c0.7,0.2,1.3,0.5,1.8,0.9c0.4,0.4,0.8,0.8,1,1.4c0.2,0.6,0.4,1.2,0.3,1.8c0,0.5-0.1,1-0.2,1.5 c-0.2,0.5-0.4,0.9-0.7,1.3c-0.3,0.4-0.7,0.7-1.2,1c-0.5,0.3-1,0.5-1.6,0.6c0.3,0.2,0.5,0.4,0.7,0.7L117,20.1z M109.8,12 c0.5,0,1.1-0.1,1.6-0.2c0.4-0.1,0.8-0.3,1.1-0.6c0.3-0.3,0.5-0.6,0.7-0.9c0.2-0.4,0.2-0.8,0.2-1.2c0-0.8-0.3-1.5-0.9-2 c-0.8-0.5-1.7-0.7-2.7-0.7h-2.2V12H109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.3,12.5v6.1c-0.8,0.5-1.6,1-2.5,1.3c-0.9,0.3-1.9,0.4-2.9,0.4c-1.2,0-2.3-0.2-3.4-0.6 c-1-0.4-1.9-0.9-2.6-1.6c-0.7-0.7-1.3-1.6-1.7-2.5c-0.4-1-0.6-2.1-0.6-3.2c0-1.1,0.2-2.2,0.6-3.2c0.3-0.9,0.9-1.8,1.6-2.5 c0.7-0.7,1.6-1.3,2.5-1.6c1.1-0.4,2.2-0.6,3.3-0.6c0.6,0,1.2,0,1.7,0.1c0.5,0.1,1,0.2,1.5,0.4c0.4,0.2,0.9,0.4,1.3,0.6 c0.4,0.2,0.7,0.5,1.1,0.8l-0.7,1c-0.1,0.2-0.2,0.3-0.4,0.3c-0.2,0-0.4,0-0.6-0.1L134,7.2c-0.3-0.2-0.5-0.3-0.8-0.4 c-0.4-0.1-0.7-0.2-1.1-0.3c-0.5-0.1-1-0.1-1.5-0.1c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.3-1.3,0.7-1.8,1.2c-0.5,0.5-0.9,1.2-1.1,1.9 c-0.3,0.8-0.4,1.6-0.4,2.5c0,0.9,0.1,1.7,0.4,2.6c0.3,0.7,0.7,1.4,1.2,1.9c0.5,0.5,1.1,1,1.8,1.2c0.8,0.3,1.6,0.4,2.4,0.4 c0.6,0,1.2-0.1,1.8-0.2c0.3-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.5-0.2,0.8-0.4v-3.3h-2.3c-0.1,0-0.3,0-0.4-0.1 c-0.1-0.1-0.1-0.2-0.1-0.3v-1.3H136.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.5,20.1h-2.3V4.5h2.3V20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.6,5.4c0,0.3-0.1,0.5-0.2,0.8l-8.6,12.1h8.7v1.9h-11.7v-0.9c0-0.1,0-0.2,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3 l8.6-12.1h-8.4V4.5h11.4L165.6,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.6,18.2v1.9H173V4.5h9.6v1.9h-7.3v4.9h5.9v1.8h-5.9v5.1L182.6,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.9,18.2v1.9h-9.6V4.5h9.6v1.9h-7.3v4.9h5.9v1.8h-5.9v5.1L199.9,18.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergezee);
export default __webpack_public_path__ + "static/media/energezee.6f9c7059a6eb9bdd51ce26aa3f38a92f.svg";
export { ForwardRef as ReactComponent };